export default __webpack_public_path__ + "static/media/sensor_marker_online.8e623808.svg";